var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';
import { get } from 'lodash';
import React, { useState } from 'react';
import * as yup from 'yup';
import { updateMedicationList, validateExistingMedicationListName } from '../../Async/MedicationListsAsync';
import { PermissionsCheck } from '../../Components/Auth/PermissionsCheck';
import { Button, ButtonMode, ButtonVariant } from '../../Components/Button';
import { StyledDialog } from '../../Components/Dialog/StyledDialog';
import { StyledDialogButton } from '../../Components/Dialog/StyledDialogButton';
import { getErrorIfTouchedFromObject } from '../../Components/FormikFields/getErrorText';
import { Header } from '../../Components/Header/Header';
import { CloseIcon, MedicationListIcon } from '../../Components/Icons';
import { NavMenu } from '../../Components/NavMenu/NavMenu';
import { StaticNavMenuItem } from '../../Components/NavMenu/StaticNavMenu';
import { StyledNavigationPrompt } from '../../Components/Prompts/StyledNavigationPrompt';
import { displayMessage } from '../../Config/ApplicationConfig';
import { useMedicationSettings } from '../../Config/MedicationConfig';
import { MedicationLocale, requiredField } from '../../Medications.en';
import { MedicationsPermissions } from '../../MedicationsPermissions';
import { debouncePromise } from '../../Shared/debouncePromise';
import { convertValidationResultToErrorsObjectV2, isDomainValidationError } from '../../Shared/DomainValidationFunctions';
import { white50 } from '../../Styles/Colours';
import { createMedicationListStepFields, MedicationListFormErrors_TypeMissing, MedicationListInformationStep } from '../MedicationListSharedSteps/MedicationListInformationStep';
var debouncedValidateExistingMedicationListName = debouncePromise(validateExistingMedicationListName, 250);
var NavLinks;
(function (NavLinks) {
    NavLinks["Details"] = "details";
})(NavLinks || (NavLinks = {}));
var createMedicationListSchema = yup
    .object({
    id: yup.string(),
    name: yup
        .string()
        .required(requiredField)
        .test({
        name: 'Name must be unique',
        message: 'Duplicate medication name exists',
        test: function validateName(value) {
            return __awaiter(this, void 0, void 0, function () {
                var parent, result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            parent = this.parent;
                            if (!value)
                                return [2 /*return*/, true];
                            return [4 /*yield*/, debouncedValidateExistingMedicationListName(value, parent.id)];
                        case 1:
                            result = _a.sent();
                            return [2 /*return*/, result.success];
                    }
                });
            });
        }
    }),
    isScopeOfPracticeList: yup.bool().required(requiredField),
    isFormulary: yup.bool().required(requiredField),
    isDefaultList: yup.bool().required(requiredField)
})
    .test({
    name: 'One type of list must be chosen',
    message: 'One type of list must be chosen',
    test: function (value) {
        if (value.isDefaultList)
            return true;
        if (value.isScopeOfPracticeList)
            return true;
        if (value.isFormulary)
            return true;
        return this.createError({
            message: 'Medication list type required.',
            path: MedicationListFormErrors_TypeMissing
        });
    }
});
var useStyles = makeStyles({
    header: {
        marginBottom: 24
    }
});
var getMedListStepErrors = function (step, errors, touchedFields) {
    switch (step) {
        case NavLinks.Details: {
            var map = createMedicationListStepFields.flatMap(function (fieldName) {
                return getErrorIfTouchedFromObject(fieldName, errors, touchedFields);
            });
            map = __spreadArray(__spreadArray([], __read(map), false), [get(errors, MedicationListFormErrors_TypeMissing, '')], false);
            return map.filter(function (it) { return !!it; }).length;
        }
    }
    return 0;
};
export var EditMedicationListDialog = function (props) {
    var styles = useStyles(props);
    var _a = __read(useState(NavLinks.Details), 2), activeLink = _a[0], setActiveLink = _a[1];
    var medicationSettings = useMedicationSettings();
    return (React.createElement(Formik, { initialValues: {
            id: props.medicationList.id,
            name: props.medicationList.name,
            isScopeOfPracticeList: props.medicationList.isScopeOfPracticeList,
            isDefaultList: props.medicationList.isDefaultList,
            isFormulary: props.medicationList.isFormulary
        }, validationSchema: createMedicationListSchema, onSubmit: function (values, formikActions) { return __awaiter(void 0, void 0, void 0, function () {
            var payload, err_1, errors;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = __assign(__assign({}, values), { authoringSystemForeignKey: props.medicationList.authoringSystemForeignKey, authoringSystem: props.medicationList.authoringSystem });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, updateMedicationList(props.medicationList.id, payload)];
                    case 2:
                        _a.sent();
                        formikActions.resetForm({ values: values });
                        displayMessage('Medication list updated');
                        props.onComplete();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        if (isDomainValidationError(err_1)) {
                            errors = convertValidationResultToErrorsObjectV2(err_1.content, MedicationLocale);
                            formikActions.setErrors(errors.fieldErrors);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); } }, function (formProps) {
        return (React.createElement(StyledDialog, { open: true, size: 'lg', modal: true, testId: 'edit-medication-list', title: 'Edit medication list', sidebarRender: function (_a) {
                var collapsed = _a.collapsed;
                return (React.createElement(NavMenu, { isCollapsed: collapsed },
                    React.createElement(StaticNavMenuItem, { isCollapsed: collapsed, errors: getMedListStepErrors(NavLinks.Details, formProps.errors, formProps.touched), icon: React.createElement(MedicationListIcon, { size: '24' }), onClick: function () {
                            setActiveLink(NavLinks.Details);
                        }, title: 'Medication list details', isActive: activeLink === NavLinks.Details, testId: 'medication-list-details' })));
            }, onRequestClose: props.onClose, titleBarRight: React.createElement(React.Fragment, null,
                React.createElement(Tooltip, { title: 'Close' },
                    React.createElement(Button, { iconOnly: true, onClick: props.onClose, noShadowOnHover: true, subtleShadeOnHover: true, testId: "navigation-control-close" },
                        React.createElement(CloseIcon, { size: '20', color: white50, noPadding: true })))), actions: React.createElement(React.Fragment, null,
                React.createElement(StyledDialogButton, { mode: ButtonMode.solid, variant: ButtonVariant.light, width: 161, key: 'close', onClick: props.onClose, testId: "navigation-control-close" }, "Cancel"),
                React.createElement(PermissionsCheck, { key: 'save', permission: MedicationsPermissions.WriteMedicationLists },
                    React.createElement(StyledDialogButton, { disabled: formProps.isSubmitting || formProps.isValidating, width: 161, testId: 'navigation-control-save', onClick: function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            formProps.submitForm();
                        } }, "Save"))) },
            React.createElement("div", { className: styles.header },
                React.createElement(Header, { title: 'Medication list details', updatedOn: props.medicationList.lastUpdatedOn, updatedBy: props.medicationList.lastUpdatedBy, createdOn: props.medicationList.createdOn })),
            React.createElement("div", null, activeLink === NavLinks.Details && React.createElement(MedicationListInformationStep, { verbalOrderTerm: medicationSettings.settings.verbalOrderTerm })),
            React.createElement(StyledNavigationPrompt, { when: formProps.dirty, onSave: formProps.submitForm })));
    }));
};
